import PropTypes from "prop-types";

import PresentIcon from "@/icons/PresentIcon";
import contentTypes from "@/view/constants/contentTypes";
import useReadAloudMode from "@/view/ReadAloudControls/useReadAloudMode";
import useCurrentArticleLevelId from "@/view/utils/useCurrentArticleLevelId";
import VideoPresentAction from "./VideoPresentAction";
import { presentModeActionIconCss } from "./PresentAction.style";
import ArticlePresentAction from "./ArticlePresentAction";

const propTypes = {
  activeSubMenu: PropTypes.string,
  content: PropTypes.object,
  disabled: PropTypes.bool,
  handleToggleBannerMode: PropTypes.func,
  hoverLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  setActiveSubMenu: PropTypes.func,
};

const PresentAction = ({
  activeSubMenu,
  content,
  disabled,
  handleToggleBannerMode,
  hoverLabel,
  isMobile,
  setActiveSubMenu,
}) => {
  const levelId = useCurrentArticleLevelId();

  const { setIsReadAloudModeActive } = useReadAloudMode();
  const { id: contentId, content_type: contentType } = content;
  const contentIsVideo = contentType === contentTypes.INTERACTIVE_VIDEO;

  const actionName = "Present";

  const eventProperties = {
    objectType: "Content",
    actionName: "Page View",
    streamProperties: {
      content_type: contentIsVideo ? "interactivevideolink" : "Article",
      description: contentIsVideo
        ? "Show present options"
        : "Toggle Presenter Mode",
      content_id: contentIsVideo ? contentId : levelId,
    },
  };

  const onClick = () => {
    setIsReadAloudModeActive(false);
    handleToggleBannerMode();
  };
  const icon = <PresentIcon css={presentModeActionIconCss} />;

  const ariaProps = {
    "aria-label": "Present",
  };

  if (contentIsVideo) {
    return (
      <VideoPresentAction
        actionName={actionName}
        activeSubMenu={activeSubMenu}
        contentId={contentId}
        content={content}
        disabled={disabled}
        eventProperties={eventProperties}
        handleToggleBannerMode={onClick}
        hoverLabel={hoverLabel}
        icon={icon}
        isMobile={isMobile}
        setActiveSubMenu={setActiveSubMenu}
      />
    );
  }

  return (
    <ArticlePresentAction
      ariaProps={ariaProps}
      actionName={actionName}
      activeSubMenu={activeSubMenu}
      disabled={disabled}
      eventProperties={eventProperties}
      handleToggleBannerMode={onClick}
      hoverLabel={hoverLabel}
      icon={icon}
      isMobile={isMobile}
    />
  );
};

PresentAction.propTypes = propTypes;

export default PresentAction;
